import { apiClient } from '@/services/api';
import type {
  LeaderboardEntry,
  LeaderboardMeResponse,
  LeaderboardResponse,
} from '@/types/leaderboard';

export const leaderboardService = {
  async top(): Promise<LeaderboardEntry[]> {
    const { entries } = await apiClient.get<LeaderboardResponse>('/api/v1/leaderboard');
    return entries;
  },

  async me(): Promise<number | null> {
    const { rank } = await apiClient.get<LeaderboardMeResponse>('/api/v1/leaderboard/me');
    return rank;
  },
};
